/* eslint-disable */
import PaymentLeft from 'components/payment/PaymentLeft'
import PaymentRight from 'components/payment/PaymentRight'
import { useRequest } from 'hooks/useRequest'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllBasketFunc } from 'redux/features/general/generalSlice'
import auth from 'utils/Auth'
import images from 'assets/images/images'
import { Helmet } from 'react-helmet'
import LoaderTwo from './LoaderTwo'
import useTranslate from 'hooks/useTranslate'
import { dataLayerPush } from 'utils/Datalayer'

export const PaymentModal = ({paymentModalContent,setPaymentModal}) => {
  return (
    <div className='paymentModal'>
         <div className='paymentModal-container'>
           <div className='paymentModal-title'>
              {/* <div>Ödeme</div> */}
              <img onClick={() => setPaymentModal(false)} src={images.close} alt="" />
           </div>
           {paymentModalContent}
        </div>     
    </div>
  )
}

const Payment = () => {
  //const [getAllBasketPayment, setGetAllBasketPayment] = useState([])
  const {getAllBasket, useTrigger} = useSelector(state => state.general);
  const dispatch = useDispatch();
  const [request,loading] = useRequest();
  const [paymentModal, setPaymentModal] = useState(false)
  const [paymentModalContent, setPaymentModalContent] = useState(null)
  const {t} = useTranslate()
  const [paymentChoice, setPaymentChoice] = useState({
    userAddressId : null, 
    paymentTypeId: null, 
    wantService:null, 
    wantContactlessDelivery:false, 
    futureDeliveryDate:null, 
    note:null,
    // prePaymentParameters: {
    //   cardNumber: null
    // },
    // paymentParameters: {
    //   cardNumber: null,
    //   otpRefCode: null,
    //   otp: null
    // }
  })


  useEffect(() => {
    if (localStorage.getItem('paymentChoice')) {
      setPaymentChoice(prev => ({...prev,...JSON.parse(localStorage.getItem('paymentChoice')), userAddressId : auth.getUserChoises()?.addressId ? auth.getUserChoises()?.addressId : null}))
      localStorage.removeItem('paymentChoice')
    } else {
      setPaymentChoice(prev => ({...prev, userAddressId : auth.getUserChoises()?.addressId ? auth.getUserChoises()?.addressId : null}))
    }
    
  },[])

  const headerOptions = {
    RestaurantId : auth?.getUserChoises()?.restaurantId,
    DeliveryType : auth?.getUserChoises()?.deliveryType,
    NeighbourhoodId : auth?.getUserChoises()?.neighbourhoodId,
    RegionId : auth?.getUserChoises()?.regionId,
  }
  const getPostArray = (orderResult) => {
    const mappedArray = orderResult?.attributes?.length > 0 ? orderResult?.attributes?.map(attribute => {
      return {
        affilication: "Tavuk Dünyası",
        item_brand: "Tavuk Dünyası",
        item_list_name: "Listeleme Sayfası",
        quantity: orderResult?.quantity || 1,
        item_variant: 'Ek Ürün',
        item_id: attribute?.productAttributeId,
        price: attribute?.price || 0,
        discount: 0,
        item_category: attribute?.name,
        item_name: attribute?.valueName,

      }
    }) : []
    return mappedArray
  }
  useEffect(() => {
    request('/ShoppingCart', {
      method: 'GET',
      headers: headerOptions
    }).then((res) => {
      if(res){
         dispatch(getAllBasketFunc(res?.data?.result))
         //setGetAllBasketPayment(res?.data?.result)
        console.log(res?.data?.result,'res');
        
         if(res?.data?.result?.items?.length > 0){
          const postArray = res?.data?.result?.items?.map((item) => {
            const productAttributes = item?.attributes
            const breadSelection = productAttributes?.find((a) => a?.name?.includes("Ekmek"))?.values?.find((a) => a?.isPreSelected)?.name
            const saladSelection = productAttributes?.find((a) => a?.name?.includes("Salata"))?.values?.find((a) => a?.isPreSelected)?.name
            const promotionSelection = productAttributes?.find((a) => a?.name?.includes("Promosyon"))?.values?.find((a) => a?.isPreSelected)?.name
            if(item?.attributes?.length > 0){
              return [
                ...[{
                  item_name: item?.productName,
                  affilication: "Tavuk Dünyası",
                  discount: item?.discountAmount,
                  item_variant:'Ana Ürün',
                  index: 0,
                  item_brand: "Tavuk Dünyası",
                  item_list_name: "Listeleme Sayfası",
                  bread_selection: breadSelection || "" , // kullanıcı seçimine göre değişecek
                  salad_selection: saladSelection || "" , // kullanıcı seçimine göre değişecek
                  promotion_selection: promotionSelection || "" , // kullanıcı seçimine göre değişecek
                  price: item?.price,
                  quantity: item?.quantity,
                  item_id: item?.productId,
                  item_category: item?.categories?.[0]?.value,
                  item_category2: item?.categories?.[1]?.value ? item?.categories?.[1]?.value : "",
                  item_category3: item?.categories?.[2]?.value ? item?.categories?.[2]?.value: "",
              }],
                ...getPostArray(item)
              ]
            }
            return [ {
              item_name: item?.productName,
              affilication: "Tavuk Dünyası",
              discount: item?.discountAmount,
              item_variant:'Ana Ürün',
              index: 0,
              item_brand: "Tavuk Dünyası",
              item_list_name: "Listeleme Sayfası",
              bread_selection: breadSelection || "" , // kullanıcı seçimine göre değişecek
              salad_selection: saladSelection || "" , // kullanıcı seçimine göre değişecek
              promotion_selection: promotionSelection || "" , // kullanıcı seçimine göre değişecek
              price: item?.price,
              quantity: item?.quantity,
              item_id: item?.productId,
              item_category: item?.categories?.[0]?.value,
              item_category2: item?.categories?.[1]?.value ? item?.categories?.[1]?.value : "",
              item_category3: item?.categories?.[2]?.value ? item?.categories?.[2]?.value: "",
          }]
          })
          const mergedArray = [].concat(...postArray);
          dataLayerPush({ ecommerce: null });
          dataLayerPush({
            event:"view_cart",
            currency: "TRY",
            value: res.data.result.orderTotal,
            ecommerce: {
              item_list_name: "Listeleme Sayfası",
              currency: "TRY",
              items: mergedArray
            }
          })
         }
      }
    })
  },[dispatch, useTrigger])

  useEffect(() => {
		window.scrollTo(0, 0)
	}, [])

  return (
    <div className='payment'>
           <LoaderTwo isDataLoading={loading} />
           <Helmet>
              <title>{t('cardAndPayment')}</title>
            </Helmet>
           {paymentModal && <PaymentModal paymentModalContent={paymentModalContent} setPaymentModal={setPaymentModal}/>}
           <PaymentLeft propLoading={loading} setPaymentChoice={setPaymentChoice} paymentChoice={paymentChoice}  getAllBasketPayment={getAllBasket}/>
           <PaymentRight propLoading={loading} setPaymentModal={setPaymentModal} setPaymentModalContent={setPaymentModalContent} setPaymentChoice={setPaymentChoice} paymentChoice={paymentChoice} getAllBasketPayment={getAllBasket}/>
    </div>
  )
}

export default Payment